// Certaines variables système valent plusieurs lignes : une adresse est la
// concaténation de la rue, du complément et du « code postal + ville » (cf.
// full_address côté Rails). Le nombre de lignes rendu est un choix de mise en
// page, porté par l'occurrence insérée (data de l'entité Draft) et non par la
// variable : la même adresse peut tenir sur une ligne dans un en-tête et sur
// trois dans un bloc destinataire.
export const VARIABLE_LINE_STYLES = {
  FULL: 'full',
  TWO: 'two',
  ONE: 'one',
};

export const DEFAULT_VARIABLE_LINE_STYLE = VARIABLE_LINE_STYLES.FULL;

const DEFAULT_SEPARATOR = ' ';
// Ponctuation collée au mot qui précède (« rue, 75001 Paris ») ; tout autre
// séparateur est entouré d'espaces (« rue - 75001 Paris »).
const TRAILING_SPACE_ONLY = [',', ';', '.', ':'];

// Le séparateur est saisi librement sur l'occurrence (data de l'entité) : seul
// le symbole est stocké, les espaces autour sont posés ici. Vide = espace.
export const formatVariableSeparator = (separator) => {
  const symbol = typeof separator === 'string' ? separator.trim() : '';
  if (!symbol) return DEFAULT_SEPARATOR;
  return TRAILING_SPACE_ONLY.includes(symbol) ? `${symbol} ` : ` ${symbol} `;
};

// Les lignes vides sont écartées : une adresse sans complément arrive avec une
// ligne vide au milieu, elle rendrait « rue, , 75001 Paris ».
const splitLines = (text) =>
  text
    .split('\n')
    .map((line) => line.trim())
    .filter((line) => line !== '');

export const applyVariableLineStyle = (text, lineStyle, separator) => {
  if (typeof text !== 'string') return text;
  if (!lineStyle || lineStyle === VARIABLE_LINE_STYLES.FULL) return text;

  const lines = splitLines(text);
  // Déjà sur une seule ligne (ou vide) : rien à regrouper. On renvoie le texte
  // d'origine et pas `lines[0]`, pour ne pas manger la valeur ' ' que porte une
  // variable vide (cf. hideEmptyVariables dans dataSync).
  if (lines.length < 2) return text;

  const joint = formatVariableSeparator(separator);
  if (lineStyle === VARIABLE_LINE_STYLES.ONE) return lines.join(joint);
  if (lineStyle === VARIABLE_LINE_STYLES.TWO) {
    return `${lines.slice(0, -1).join(joint)}\n${lines[lines.length - 1]}`;
  }
  return text;
};
